import { render, staticRenderFns } from "./ToggleFavorite.vue?vue&type=template&id=2a0ea2ba&scoped=true"
import script from "./ToggleFavorite.vue?vue&type=script&lang=ts"
export * from "./ToggleFavorite.vue?vue&type=script&lang=ts"
import style0 from "./ToggleFavorite.vue?vue&type=style&index=0&id=2a0ea2ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ea2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0ea2ba')) {
      api.createRecord('2a0ea2ba', component.options)
    } else {
      api.reload('2a0ea2ba', component.options)
    }
    module.hot.accept("./ToggleFavorite.vue?vue&type=template&id=2a0ea2ba&scoped=true", function () {
      api.rerender('2a0ea2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/favorite/ToggleFavorite.vue"
export default component.exports